var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.738 4.64062C13.2721 4.64357 14.6084 4.65649 16.0282 4.71336L16.5316 4.7353C17.9611 4.80298 19.3894 4.91861 20.0978 5.11613C21.0427 5.38158 21.7854 6.15613 22.0364 7.13795C22.4361 8.69704 22.4861 11.74 22.4923 12.4764L22.4932 12.629V12.6397C22.4932 12.6397 22.4932 12.6434 22.4932 12.6505L22.4923 12.8031C22.4861 13.5395 22.4361 16.5825 22.0364 18.1416C21.7819 19.127 21.0392 19.9016 20.0978 20.1634C19.3894 20.3609 17.9611 20.4765 16.5316 20.5442L16.0282 20.5661C14.6084 20.623 13.2721 20.6359 12.738 20.6389L12.5036 20.6397H12.4932C12.4932 20.6397 12.4897 20.6397 12.4828 20.6397L12.2486 20.6389C11.1182 20.6327 6.39186 20.5816 4.88865 20.1634C3.94374 19.8979 3.20106 19.1234 2.95001 18.1416C2.55034 16.5825 2.50038 13.5395 2.49414 12.8031V12.4764C2.50038 11.74 2.55034 8.69704 2.95001 7.13795C3.20454 6.15249 3.94722 5.37795 4.88865 5.11613C6.39186 4.69786 11.1182 4.64684 12.2486 4.64062H12.738ZM10.4933 9.13976V16.1397L16.4932 12.6397L10.4933 9.13976Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.fa60be0254d01b373e419f4078d4a41e.svg";
export { ForwardRef as ReactComponent };